import cx from "classnames";

import CS from "metabase/css/core/index.css";
import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

import rctechCloudLogo from "./rctech-cloud-logo.png";

interface LogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

const LOGO_ASPECT_RATIO = 110 / 73;

export const DefaultLogoIcon = ({
  dark,
  height = 32,
  width,
}: LogoIconProps) => {
  return (
    <img
      className={cx(
        "Icon",
        { [CS.textMetabaseBrand]: !dark },
        { [CS.textWhite]: dark },
      )}
      src={rctechCloudLogo}
      alt="RCTECH BI"
      width={width}
      height={height}
      style={{
        width: width ?? (height ? height * LOGO_ASPECT_RATIO : undefined),
        height: height ?? (width ? width / LOGO_ASPECT_RATIO : undefined),
        objectFit: "contain",
      }}
      data-testid="main-logo"
    />
  );
};

export function LogoIcon(props: LogoIconProps) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
